import { AuthClient } from "@/utils/client";
import urlcat from "urlcat";

/**
 *
 * @param limit limit of the data, pass empty string to get all data
 * @param page page number
 * @param search search query
 * @param sortBy sort by field
 * @param otherFilters other filters
 * @returns list of my mineral collection
 */
export const getMyMineralCollection = (
  limit?: number | string,
  page?: number,
  search?: string,
  sortBy: string = "createdAt",
  sortOrder: string = "desc",
  otherFilters?: any,
) => {
  const url = urlcat("/common/my-collection", {
    limit,
    page,
    search,
    sortBy,
    sortOrder,
  });

  return AuthClient().post(url, otherFilters);
};

export const updatedCatalogIcon = () => {
  return AuthClient().patch(`/common/update-catalog-icon`);
};

export const getLatestMineral = (
  limit?: number | string,
  page?: number,
  // search?: string,
  sortBy?: string,
  currentPage?: string,
  // sortOrder: string = "desc",
  // otherFilters?: any
) => {
  const url = urlcat("/common/latest-minerals", {
    limit,
    page,
    // search,
    sortBy,
    currentPage,
    // sortOrder
  });

  return AuthClient().get(url);
};

export const getMyLikedMineralCollection = (
  limit?: number | string,
  page?: number,
  search?: string,
  sortBy: string = "like",
  otherFilters?: any,
) => {
  const url = urlcat("/common/my-collection", {
    limit,
    page,
    search,
    sortBy,
  });

  return AuthClient().post(url, otherFilters);
};

export const deleteSubCollection = (id: string) => {
  return AuthClient().delete(`/admin/subCollection/${id}`);
};

export const editSubCollection = (id: string, name: string) => {
  return AuthClient().patch(`/admin/subCollection/${id}`, { name });
};

export const createSubCollection = (data: any) => {
  return AuthClient().post(`/admin/subCollection`, data);
};
